var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery } from '@apollo/client';
import useScroll from 'utils/hooks/useScroll';
import { getPageInfo } from 'utils/paginationHelper';
import ORGANIZATIONS_FOR_SELECT from 'apollo/queries/ORGANIZATIONS_FOR_SELECT';
var useOrganizationGroupTable = function (_a) {
    var _b;
    var filterValues = _a.filterValues, id = _a.id, containerRef = _a.containerRef;
    var variables = __assign({ organization_group_ids: [id], first: 25 }, filterValues);
    var _c = useQuery(ORGANIZATIONS_FOR_SELECT, {
        variables: variables
    }), data = _c.data, loading = _c.loading, fetchMore = _c.fetchMore;
    var dataSource = ((_b = data === null || data === void 0 ? void 0 : data.organizationOptions) === null || _b === void 0 ? void 0 : _b.nodes) || [];
    var dataPath = ['organizationOptions'];
    var pageInfo = getPageInfo(dataPath)(data);
    var scrollLoading = useScroll({
        dataPath: dataPath,
        dataType: 'nodes',
        fetchMore: fetchMore,
        pageInfo: pageInfo,
        isTable: true,
        filterUniqueIds: true,
        tableId: '',
        scrollRef: containerRef,
        isHorizontalScroll: false
    }).scrollLoading;
    return {
        data: {
            loading: loading,
            organizations: dataSource,
            scrollLoading: scrollLoading
        }
    };
};
export default useOrganizationGroupTable;
